import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import EntityForm from '../../containers/EntityForm';
import EntityNameField from '../../containers/EntityForm/fields/EntityNameField';
import TextAreaField from '../../containers/EntityForm/fields/TextAreaField';
import useT from '../../utils/Translations/useT';
import EntityFormFieldSet from '../../containers/EntityForm/EntityFormFieldSet';
import useQuickLinks from '../../../data/hooks/useQuickLinks';
const MAX_NAME_LENGTH = 35;
const AddQuickLinkForm = ({ onCancel, entity, }) => {
    const history = useHistory();
    const t = useT();
    const { mutations: { createPersonQuickLink, updatePersonQuickLink }, } = useQuickLinks();
    const _onSubmit = useCallback(async ({ name, description }) => {
        if (entity === null || entity === void 0 ? void 0 : entity.id) {
            await updatePersonQuickLink({
                id: entity.id,
                name,
                description,
                url: entity.url,
            });
        }
        else {
            await createPersonQuickLink({
                name,
                description,
                url: entity.url || history.location.pathname,
            });
        }
        return onCancel();
    }, [createPersonQuickLink, updatePersonQuickLink, entity, history, onCancel]);
    const _entity = useMemo(() => ({ ...entity }), [entity]);
    const isNew = useMemo(() => !entity.id, [entity]);
    return (<EntityForm isAlwaysEditable columns={1} createLabel={t('Save')} entity={_entity} isCopied={isNew ? true : undefined} successMessageText="Quick Link added successfully" onCancel={onCancel} onSubmit={_onSubmit}>
      <EntityFormFieldSet>
        <EntityNameField required dataCy="quick-link-name-field" label={t('Quick Link Name')} maxLength={MAX_NAME_LENGTH}/>
        <TextAreaField noLabel dataCy="quick-link-description-field" name="description" placeholder={t('Enter description (optional)')}/>
      </EntityFormFieldSet>
    </EntityForm>);
};
export default AddQuickLinkForm;
